import { IdeaDTO, IdeaPlanDTO } from 'src/dtos/Idea';
import { SourceStage } from 'src/lib/tableStages';

export class UniversePlanDTO extends IdeaPlanDTO {
    universeId: string;

    constructor(universeId: string) {
        super();
        this.universeId = universeId;
    }

    override async toStage(): Promise<SourceStage | null> {
        return SourceStage.fromTickerUniverseId(this.universeId);
    }

    override toContract(): never {
        throw new Error('UniversePlanDTO is a local source selection. Use SourceStage.fromTickerUniverseId().');
    }

    static fromUniverseId(universeId: string): UniversePlanDTO {
        return new UniversePlanDTO(universeId);
    }

    toJSON() {
        return { universeId: this.universeId };
    }

    /**
     * @deprecated - This is a temporary measure for creating runnable ideas. Long-term we should keep idea states.
     */
    toTempIdea(): IdeaDTO<UniversePlanDTO> {
        return IdeaDTO.fromIdeaAndPlan(
            {
                name: 'Universe Idea',
                key: 'ticker',
                isTemplate: false,
                description: null,
                defaultUniverseId: null,
                defaultColumnTemplateId: null,
            },
            this,
        ) as IdeaDTO<UniversePlanDTO>;
    }
}
